import { Helmet } from "react-helmet";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";

// Pirate Hans
// Jinx
import jinx6 from "img/jungles/Jinx/StripedFemaleJungle-2.jpg";
// Tarzan
import Image from "components/image";
import collectionMeta from "content/collections/jungle-carpet-python.json";
import { animalGridFromJson } from "hooks/useGallery";

const animalGridData = animalGridFromJson(collectionMeta);

const JungleCarpetPython = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Jungle Carpet Pythons (Morelia spilota cheynei)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/jungle-carpet-python" />
      </Helmet>
      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />
      <AnimalGrid data={animalGridData} />
      <BodyText>
        I probably learned about Jungle Carpet pythons from reading Reptiles
        magazine back in the mid 1990s, and I'm sure it was from an ad in the
        back of one of those that I found the email address for Dave and Tracy
        Barker of VPI. I exchanged a couple of emails with Tracy and she sent me
        this picture below and that animal became my first carpet python
        purchase in 1998.
      </BodyText>
      <Image src={jinx6} caption="1997, Jinx, pic from breeder" />
      <BodyText>
        Jinx has a stripe running the length of her body and the Barkers had
        tried proving that it was a reproducible trait but after a number of
        breedings they weren't able to get a fix on the genetics involved so
        they stopped the project.
      </BodyText>
      <BodyText>
        A year after getting Jinx a friend of mine sold me Pirate Hans, who was
        already an adult at that time. He also sold me a jungle carpet that we
        named Jungle Boogie who passed away in the 2010s. Finally in 2021 I
        found Tarzan on a local online classified ad.
      </BodyText>
      <BodyText>
        I feel like I need a few more jungles including one or more zebra
        jungles. So we'll see if I'm done bringing these in.
      </BodyText>
      <PageGallery slug="jungle-carpet-python" maxWidth="900" />
    </ContentBox>
  );
};

export default JungleCarpetPython;
